import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const columnCardCarouselDefaultVariants = {}
const columnCardCarouselCompoundVariants = []

const columnCardCarouselSlotNames = [
  [
    "root",
    "column-card-carousel__root"
  ],
  [
    "cta",
    "column-card-carousel__cta"
  ]
]
const columnCardCarouselSlotFns = /* @__PURE__ */ columnCardCarouselSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, columnCardCarouselDefaultVariants, getSlotCompoundVariant(columnCardCarouselCompoundVariants, slotName))])

const columnCardCarouselFn = memo((props = {}) => {
  return Object.fromEntries(columnCardCarouselSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const columnCardCarouselVariantKeys = []
const getVariantProps = (variants) => ({ ...columnCardCarouselDefaultVariants, ...compact(variants) })

export const columnCardCarousel = /* @__PURE__ */ Object.assign(columnCardCarouselFn, {
  __recipe__: false,
  __name__: 'columnCardCarousel',
  raw: (props) => props,
  variantKeys: columnCardCarouselVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, columnCardCarouselVariantKeys)
  },
  getVariantProps
})